<nav class="navbar navbar-toggleable-md navbar-inverse bg-primary mb-5" id="grad">
    <p><img class="bottom" style="width: 85px;height: 85px;" src="../../../assets/bonanza_logo.png"> BONANZA <span
            class="white_text">{{'nav-bar.administration' | translate}}</span> <span *ngIf="loggedIn"
                                                                                     class="logged-in">{{sessionData.fullName}} ({{sessionData.tenantCode}})</span>        <span *ngIf="!loggedIn" class="logged-in">{{'nav-bar.not-loggedin' | translate}}</span></p>

    <!-- div class="dropdown pull-left " *ngIf="loggedIn && isServerAdmin ">
        <button class="btn btn-default dropdown-toggle " id="dropdownMenuManage " data-toggle="dropdown " aria-haspopup="true " aria-expanded="true ">Verwaltung</button>
        <ul class="dropdown-menu " aria-labelledby="dropdownMenuManage ">
            <a routerLink="/admin/tenants " class="dropdown-item ">Mandanten</a>
        </ul>
    </div -->

    <ng4-loader-bar [height]="'4px'"></ng4-loader-bar>


    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon "></span>
  </button>

    <!-- <a href="# " class="navbar-brand ">B4All</a> -->

    <div *ngIf="loggedIn " class="title ">{{tenantName}}</div>



    <div>
        <div>
            <div class="dropdown pull-left width" *ngIf="loggedIn ">
                <button class="btn btn-default dropdown-toggle width" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true ">
                  {{'nav-bar.event' | translate}}
        <span class="caret "></span>
      </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1 ">
                    <a routerLink="/products/simpleTravels" class="dropdown-item ">  {{'nav-bar.travel' | translate}}</a>
                    <a routerLink="/products/suppliers" class="dropdown-item ">  {{'nav-bar.provider' | translate}}</a>
                </ul>
            </div>
        </div>
        <div>
            <button *ngIf="loggedIn" type="button " class="btn btn-default width" (click)="logout() ">{{'nav-bar.logout' | translate}}</button>
        </div>
        <div *ngIf="loggedIn">
            <select *ngIf="isSalesMode" [(ngModel)]="userType" name="userType" (change)="changeUserType(userType)" class="form-control width" id="travel.at">
                <option  value="simpleTravel"  > {{'nav-bar.premium' | translate}}</option>
                <option value="basicTravel"  >{{'nav-bar.standard' | translate}}</option>
              </select>
        </div>
        <div>
            <div class="dropdown pull-left width">
                <button class="btn btn-default dropdown-toggle width" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
      {{'nav-bar.select-language' | translate}}
      <span class="caret "></span>
    </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                    <!-- <a *ngFor="let lang of acceptedLanguages" (click)="changeLanguage(lang)" class="dropdown-item">{{lang}}</a> -->
                    <a (click)="changeLanguage('de_DE')" [ngClass]="{'selected': selectedLanguage === 'de_DE' }" class="dropdown-item"> {{'languages.german' | translate}}</a>
                    <a (click)="changeLanguage('en_UK')" [ngClass]="{'selected': selectedLanguage === 'en_UK' }" class="dropdown-item"> {{'languages.english' | translate}}</a>
                    <a (click)="changeLanguage('fr_FR')" [ngClass]="{'selected': selectedLanguage === 'fr_FR' }" class="dropdown-item"> {{'languages.france' | translate}}</a>
                    <a (click)="changeLanguage('nl_NL')" [ngClass]="{'selected': selectedLanguage === 'nl_NL' }" class="dropdown-item"> {{'languages.netherland' | translate}}</a>
                </ul>
            </div>
        </div>
    </div>
    <!--
    <div class="collapse navbar-collapse " id="navbarNav ">
        <ul class="navbar-nav ">
            <li class="nav-item dropdown " ngbDropdown>
                <a ngbDropdownToggle class="nav-link dropdown-toggle " id="navbarDropdownProductLink " data-toggle="dropdown " aria-haspopup="true " aria-expanded="false ">Veranstaltungen</a>
                <div class="dropdown-menu " aria-labelledby="navbarDropdownProductLink ">
                    <a routerLink="/products/simpleTravels " class="dropdown-item ">Reisen</a>
                    <a routerLink="/products/suppliers " class="dropdown-item ">Anbieter</a>
                </div>
            </li>
        </ul>
    </div>-->


</nav>

<!-- <ng-progress></ng-progress> -->



// WEBPACK FOOTER //
// ./src/app/core/nav/nav.component.html